export const PlanReviewFileFragment = gql`
  fragment PlanReviewFileFragment on File {
    ...FileFragment
    initialPlansSetVersionNumber
    pageProcessingFinishedAt
    pages {
      ...PlanReviewFilePageFragment
    }
  }
  fragment PlanReviewFilePageFragment on FilePage {
    id
    fileId
    heightPx
    pageNumber
    renderStatus
    rotationDegrees
    widthPx
    isModifiedOnRecordPlansSet(currentRecordPlansSetId: $recordPlansSetId)
  }
`
export const PlanReviewFieldGroupFragment = gql`
  fragment PlanReviewFieldGroupFragment on FieldGroup {
    id
    fields {
      ...PlanReviewFieldFragment
    }
  }
  fragment PlanReviewFieldFragment on Field {
    id
    label
    file {
      ...PlanReviewFileFragment
    }
    files {
      ...PlanReviewFileFragment
    }
  }
`
